import { appEntry } from '@/pages/home/mocks/data';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-full max-w-sm lg:max-w-md">
            <img
              src={appEntry.imageUrl}
              alt="51吃瓜APP下载"
              className="w-full h-auto object-contain"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
              官方下载
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">{appEntry.title}</h2>
            <p className="text-foreground-600 mb-6 leading-relaxed">{appEntry.subtitle}</p>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
              {appEntry.features.map((f) => (
                <span key={f} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-50 border border-background-200 rounded-full text-xs text-foreground-600">
                  <i className="ri-check-line text-primary-500 text-xs"></i>
                  {f}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              {appEntry.badges.map((badge) => (
                <a
                  key={badge.label}
                  href="#app"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className={`${badge.icon} text-base`}></i>
                  {badge.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}